import { ShieldCheck } from "lucide-react";
import { site } from "../content";
import { Reveal, SectionHeading } from "./Reveal";

export default function Specs() {
  return (
    <section id="especificacoes" data-testid="specs-section" className="relative py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid gap-16 lg:grid-cols-[1fr_1.2fr]">
          <div>
            <SectionHeading
              chapter="10"
              eyebrow="Especificações técnicas"
              title="Conheça o equipamento"
              testId="specs-heading"
            />
            <Reveal delay={0.2}>
              <div
                data-testid="safety-block"
                className="mt-12 rounded-3xl border border-white/10 bg-graphite/60 p-8 backdrop-blur-xl"
              >
                <div className="flex items-center gap-3">
                  <ShieldCheck className="h-5 w-5 text-gold" aria-hidden="true" />
                  <h3 className="font-display text-sm font-extrabold uppercase tracking-[0.2em] text-bone">
                    Projetado para a rotina profissional
                  </h3>
                </div>
                <ul className="mt-6 space-y-3.5">
                  {site.safety.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm text-bone/65">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" aria-hidden="true" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <div className="overflow-hidden rounded-3xl border border-white/10 bg-graphite/60 backdrop-blur-xl">
              <table className="w-full text-left" data-testid="specs-table">
                <tbody>
                  {site.specs.map(([label, value], i) => (
                    <tr
                      key={label}
                      className={`transition-colors duration-300 hover:bg-gold/[0.04] ${
                        i !== 0 ? "border-t border-white/[0.07]" : ""
                      }`}
                    >
                      <th
                        scope="row"
                        className="w-2/5 px-6 py-4.5 align-top font-display text-[11px] font-bold uppercase tracking-[0.18em] text-bone/45 md:px-8 md:py-5"
                      >
                        {label}
                      </th>
                      <td className="px-6 py-4.5 align-top text-sm font-medium leading-relaxed text-bone/85 md:px-8 md:py-5">
                        {value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
